//
//  SDKWorkspaceSSOSettings.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Object Definition
export class WorkspaceSSOSettings {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        this.providerId = model.providerId;
        this.defaultAutoInviteValue = model.defaultAutoInviteValue;
        this.autoInviteDomains = model.autoInviteDomains;
        this.areInvitesDisabled = model.areInvitesDisabled;
        this.skipDocsSupernovaLogin = model.skipDocsSupernovaLogin;
        this.isScimEnabled = model.isScimEnabled;
        this.scimBaseUrl = model.scimBaseUrl;
    }
    // SSO settings can't be created or updated, only fetched, for now
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Serialization & Deserialization
    toUpdateObject() {
        return {
            providerId: this.providerId,
            defaultAutoInviteValue: this.defaultAutoInviteValue,
            autoInviteDomains: this.autoInviteDomains,
            areInvitesDisabled: this.areInvitesDisabled,
            skipDocsSupernovaLogin: this.skipDocsSupernovaLogin,
            isScimEnabled: this.isScimEnabled,
        };
    }
    toRemote() {
        return {
            providerId: this.providerId,
            defaultAutoInviteValue: this.defaultAutoInviteValue,
            autoInviteDomains: this.autoInviteDomains,
            areInvitesDisabled: this.areInvitesDisabled,
            skipDocsSupernovaLogin: this.skipDocsSupernovaLogin,
            isScimEnabled: this.isScimEnabled,
            scimBaseUrl: this.scimBaseUrl,
        };
    }
    toTransport() {
        return this.toRemote();
    }
    static fromTransport(model) {
        return new WorkspaceSSOSettings(model);
    }
}
